import React from 'react';

import { Alert, Breadcrumbs } from '@storebrand-digital/pretzel';
import { getText } from '@storebrand-digital/fms-translations';
import { LayoutContainer } from '../../app/LayoutContainer';
import dashboardStyles from '../Dashboard/Dashboard.module.css';

function NoMatch() {
  return (
    <LayoutContainer>
      <div className={dashboardStyles.dashboardBase}>
        <Breadcrumbs expandAllAriaLabel={getText('breadcrumb.expand.title')}>
          <a href="/oversikt">{getText('breadcrumb.overview.title')}</a>
          <a href="/arkiv">{getText('breadcrumb.documentarchive.title')}</a>
        </Breadcrumbs>
        <h1>{getText('header.title')}</h1>
        <Alert heading={getText('nomatch.title')}>
          <a href="/arkiv">{getText('nomatch.archive.href.label')}</a>
        </Alert>
      </div>
    </LayoutContainer>
  );
}

export default NoMatch;
